import { render } from "./TableText.vue?vue&type=template&id=62d49050&ts=true"
import script from "./TableText.vue?vue&type=script&lang=ts"
export * from "./TableText.vue?vue&type=script&lang=ts"

import "./TableText.vue?vue&type=style&index=0&id=62d49050&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__